import { render } from "./ApproveDifferenceModal.vue?vue&type=template&id=58397a7c&ts=true"
import script from "./ApproveDifferenceModal.vue?vue&type=script&lang=ts"
export * from "./ApproveDifferenceModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__